import { useEffect, useState } from "react";
import ModuleItem from "../forms/modules/ModuleItem";
import { ModulesMeta } from "../../constant/data";
import { Button } from "../forms";
import { FaArrowLeft, FaArrowRight, FaCheck } from "react-icons/fa";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useNavigate } from "react-router-dom";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { IoReceipt } from "react-icons/io5";
import { SearchBar } from "../generic/SearchBar";
import { onAddOrgModule } from "../../services/auth/modules";
import { table } from "console";
import { toast } from "react-toastify";
 
export default (props: any) => {
  const [selectedModules, setselectedmodules] = useState<any[]>([]);
  const [moduleCats, setModuleCats] = useState<string[]>([]);
   const { setLoading, setShowModal, setallmodules, showModal } = useStateSetter();
  const navigate = useNavigate();
  const { Allmodules,SelectedOrg ,config} = useStateGetter();
  const [allModules, setallm]=useState(Allmodules)
  const [entered, setentered] =useState("")
 
  const onChange =((e:string)=>{


setentered(e)
console.log(Allmodules)
 setallm(Allmodules.filter((i:any)=>i.moduleName.toLowerCase().includes(e.toLowerCase())))

  })

const onAddModules =async ()=>{
setLoading(true)
   await Promise.all (
   selectedModules.map( async(item)=>{
  let postdata=  {
      organizationID:SelectedOrg.id,
      moduleID: item.id
  }
  try{
    var response = await onAddOrgModule(postdata,config)
  }
  catch(e:any){

    toast(e)
  }
  }))

setLoading(false)
  showModal(
    "",
    "",
    <FaCheck
      size={30}
      className="inline  text-textbg bg-green-200 p-2 rounded-full"
    />,
    <CompanySuccess />
  );
}
  useEffect(() => {
    ModulesMeta.map((heads) => {
      setModuleCats((prev) => {
        if (!prev.includes(heads.category)) {
          return prev.concat([heads.category]);
        } else return prev;
      });
    });
  }, []);

  
  useEffect(()=>{

setallm(allModules)
  },[allModules])

  const CompanySuccess = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        Company/Business Added Successfuly{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Okay"
          onBtnClick={() => {
            setLoading(true);
            setTimeout(() => {
              navigate("/home");
              setShowModal(false);
              setLoading(false);
            }, 3000);
          }}
        />
      </div>{" "}
    </div>
  );

  const createOrg = async () => {};

  return (
    <div className=" w-[80%] p-6 bg-white overflow-y-scroll max-h-[70vh]">
      <div className="flex justify-between">
      <p className="font-bold text-sm ">Selected({selectedModules.length})</p>
      <SearchBar placeholder ="Search" onchange={onChange} value={entered} />
      </div>
     

      <div className="">
        {
        // moduleCats.map((n) => (
        //   <div className="py-4">
        //     <p className="font-bold text-gray-500"> {n} </p> 
            <div className="grid grid-cols-3 gap-4">
              {allModules.map((item: any) => (
                //  item.category==n?
                <ModuleItem
                  onSelected={() => {
                    if (selectedModules.includes(item)) {
                      setselectedmodules((prev) =>
                        prev.filter((i) => i != item)
                      );
                    } else {
                      setselectedmodules((prev) => prev.concat([item]));
                    }
                  }}
                  icon={
                    <IoReceipt
                      size={50}
                      className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
                    />
                  }
                  name={item.moduleName}
                  selected={selectedModules.some(
                    (sel) => item.moduleName == sel.moduleName
                  )}
                />
                // :""
              ))}
            </div>
          /* </div>
        )) */
        }
      </div>

      <div className="w-full flex justify-between">
        <Button
          OverideStyle="text-textbg"
          width={250}
          style={" bg-white "}
          disabled={selectedModules.length > 0}
          text={
            <>
              <FaArrowLeft size={15} className=" mr-1 inline" />
              Company/Business
            </>
          }
          onBtnClick={() => {
            props.action(0);
          }}
        />

        <Button
          width={250}
          disabled={!(selectedModules.length > 0)}
          text={
            <>
              Start Now
              <FaArrowRight size={15} className=" ml-1 inline" />
            </>
          }
          onBtnClick={() => {
            
            onAddModules()
          
          }}
        />
      </div>
    </div>
  );
};
